import * as t from "io-ts";
import { ADT } from "ts-adt";

export type ViewModeString = t.TypeOf<typeof ViewModeString>;
export const ViewModeString = t.union([
  t.literal("grid"),
  t.literal("list"),
  t.literal("map"),
  t.literal("masonry"),
  t.literal("masonryho"),
]);

export type ViewMode = ADT<{
  grid: {};
  list: {};
  map: {};
  masonry: {};
  masonryho: {};
}>;

export type ViewModeInterface = {
  grid: ViewMode;
  list: ViewMode;
  map: ViewMode;
  masonry: ViewMode;
  masonryho: ViewMode;

  toString: (v: ViewMode) => ViewModeString;
  fromString: (s: ViewModeString) => ViewMode;
};

export const viewMode: ViewModeInterface = {
  grid: {
    _type: "grid",
  },
  list: {
    _type: "list",
  },
  map: {
    _type: "map",
  },
  masonry: {
    _type: "masonry",
  },
  masonryho: {
    _type: "masonryho",
  },

  toString: (mode: ViewMode) => mode._type,
  fromString: (str: ViewModeString) => viewMode[str],
};

export type ViewModeMapping = {
  attribute: ViewModeString;
  viewMode: ViewMode;
};
export const viewModeAttributesMapping: ViewModeMapping[] = [
  { attribute: "grid", viewMode: viewMode.grid },
  { attribute: "list", viewMode: viewMode.list },
  { attribute: "map", viewMode: viewMode.map },
  { attribute: "masonry", viewMode: viewMode.masonry },
  {
    attribute: "masonryho",
    viewMode: viewMode.masonryho,
  },
];

export type ViewModeParameters = {
  defaultViewMode: ViewMode;
  ButtonElements: HTMLElement[];
};
